import { useViewpostTopObserver } from "@/hooks/useViewpostTopObserver";
import { Stack } from "@chakra-ui/react";
import { responsive, VStack } from "goi_common";
import React from "react";

import GuideContent from "./components/Guide/GuideContent";
import GuideFooter from "./components/Guide/GuideFooter";
import GuideHead from "./components/Guide/GuideHead";
import GuideSummary from "./components/Guide/GuideSummary";

export default function FeedDetailContainer({ feed }: any) {
  const { viewportTopRef } = useViewpostTopObserver();
  return (
    <VStack width="100%" alignItems="center">
      <div ref={viewportTopRef}></div>
      <GuideHead
        title={feed.title}
        date={
          "20" + feed.date.replace("-", "년 ").replace("-", "월 ") + "일 작성"
        }
        imgSrc={feed.imgSrc}
      />
      <Stack
        maxWidth={`720px`}
        width="100%"
        css={responsive({
          gap: { base: "28px", md: "40px" },
          padding: { base: "0", lg: "60px 0px" },
        })}
      >
        {feed.summary && <GuideSummary summary={feed.summary} />}
        <GuideContent contents={feed.contents} isFeed />
        {/* <GuideMoreRecommendScrion title={feed.title} /> */}
        <GuideFooter />
      </Stack>
      {/* <LandingFixedButton
        color={colors.brown650}
        text="고이와 함께 100원으로 장례 준비하기"
        href="/"
        eventPath="feed"
      />
      <Footer /> */}
    </VStack>
  );
}
